import { Component, Input, OnInit } from '@angular/core';
import { NoteSection } from 'src/app/model/section/note-section';

@Component({
  selector: 'app-common-types-datalists-note-section',
  templateUrl: './common-types-datalists-note-section.component.html',
  styleUrls: ['./common-types-datalists-note-section.component.scss']
})
export class CommonTypesDatalistsNoteSectionComponent implements OnInit {
  @Input() noteSections: NoteSection[] = [];
  @Input() noteWithinTable: boolean = false;
  constructor() {}

  ngOnInit(): void {}
}
